module.exports = {
  title: '短信管理',
  route: {
    path: 'system-manage',
    children: {
      path: 'sms-list',
    },
  },
};
